import NextLink from "next/link";
import PropTypes from "prop-types";
import {
  Box,
  Card,
  CardHeader,
  Divider,
  IconButton,
  Link,
  MenuItem,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  TextField,
  Typography,
  Tooltip,
  CardContent,
} from "@mui/material";
import { Eye as Eye } from "../../../icons/eye";
import { PencilAlt as PencilAltIcon } from "../../../icons/pencil-alt";
import { Scrollbar } from "../../scrollbar";
import { CheckCircleOutline } from "@mui/icons-material";
import { useRouter } from "next/router";

export const OportunidadesNoContactadas = (props) => {
  const Router = useRouter();
  const { oportunidades = [], user } = props;

  return (
    <>
      {(oportunidades.length > 0 && (
        <Card>
          <CardHeader
            title="Procesos de venta sin contactar"
            subheader={
              oportunidades.length === 5
                ? "Hay más de 5 procesos de venta sin contactar"
                : `Hay ${oportunidades.length} procesos de venta sin contactar`
            }
          />
          <Divider />
          <Scrollbar>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell>Nombre</TableCell>
                  {user?.role !== "agente" && (
                    <TableCell>Vendedor asignado</TableCell>
                  )}
                  <TableCell>Valor de la venta</TableCell>
                  <TableCell align="right">Acciones</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {oportunidades.map((oportunidad) => {
                  return (
                    <TableRow hover key={oportunidad?.id}>
                      <TableCell>
                        <Box sx={{ ml: 1 }}>
                          <NextLink
                            href={"/dashboard/oportunidades/" + oportunidad?.id}
                            passHref
                          >
                            <Link color="inherit" variant="subtitle2">
                              {oportunidad?.contacto.name}
                            </Link>
                          </NextLink>
                          <Typography color="textSecondary" variant="body2">
                            {oportunidad?.contacto.surname
                              ? oportunidad?.contacto.surname
                              : ""}
                          </Typography>
                        </Box>
                      </TableCell>
                      {user?.role !== "agente" && (
                        <TableCell>
                          <Typography color="textSecondary" variant="subtitle2">
                            {oportunidad?.agente.name}
                          </Typography>
                          <Typography color="textSecondary" variant="subtitle2">
                            {oportunidad?.agente.distribuidora}
                          </Typography>
                        </TableCell>
                      )}
                      <TableCell>
                        <Typography color="success.main" variant="subtitle2">
                          {"$"}
                          {oportunidad?.value ? oportunidad?.value : "0.00"}
                        </Typography>
                      </TableCell>
                      <TableCell align="right">
                        <Tooltip title="Editar oportunidad">
                          <IconButton
                            onClick={() => {
                              Router.push(
                                "/dashboard/oportunidades/" +
                                  oportunidad?.id +
                                  "/editar"
                              );
                            }}
                          >
                            <PencilAltIcon fontSize="small" />
                          </IconButton>
                        </Tooltip>
                        <Tooltip title="Ver oportunidad">
                          <IconButton
                            onClick={() => {
                              Router.push(
                                "/dashboard/oportunidades/" + oportunidad?.id
                              );
                            }}
                          >
                            <Eye fontSize="small" />
                          </IconButton>
                        </Tooltip>
                      </TableCell>
                    </TableRow>
                  );
                })}
              </TableBody>
            </Table>
          </Scrollbar>
        </Card>
      )) || (
        <Card>
          <CardContent
            sx={{
              alignItems: "center",
              display: "flex",
              flexDirection: "column",
              p: 4,
            }}
          >
            <CheckCircleOutline
              sx={{
                color: "success.main",
                height: 56,
                width: 56,
              }}
            />
            <Typography color="textSecondary" variant="h5" sx={{ mt: 2 }}>
              ¡Gran trabajo!
            </Typography>
            <Typography color="textSecondary" variant="subtitle2">
              No hay oportunidades sin contactar
            </Typography>
          </CardContent>
        </Card>
      )}
    </>
  );
};

OportunidadesNoContactadas.propTypes = {
  oportunidades: PropTypes.array.isRequired,
  oportunidadesCount: PropTypes.number.isRequired,
};
